<template>
    <div class="custom-switch">
        <div class="form-check form-switch custom-switch__form-switch">
            <input class="form-check-input custom-switch__form-check-input" :id="htmlId" type="checkbox" :checked="isChecked()" @change="handleClick">
            <label class="form-check-label custom-switch__form-check-label" :for="htmlId">{{label}}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "SidebarTrueFalse",
    props: ['name', 'label'],
    computed: {
        htmlId() {
            return "flexSwitchCheck"+this.name;
        },
        request() {
            return this.$store.state.archive.request;
        }
    },
    methods: {
        isChecked() {
            return !!this.request[this.name];
        },
        handleClick() {
            this.$store.commit('archive/setFilterValue', [this.name, !this.isChecked()]);
            this.$store.commit('archive/fireTrigger');
            this.$store.commit('archive/setPage', 1);
        },
    }
}
</script>

<style scoped>

</style>
